import React from 'react';
import PropTypes from 'prop-types';
// import { Text } from '@bd/bdui-forms';

function TextField({
  className,
  label,
}) {
  return (
    <div className={className}>
      <h3 className="mt-4">{label}</h3>
    </div>
  );
}

TextField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

TextField.defaultProps = {
  className: undefined,
  label: undefined,
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/Headline.js